import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Immediate scroll to top - most aggressive
    window.scrollTo(0, 0);
    
    // Force scroll with behavior instant
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Remove hash from URL without page reload
    if (hash) {
      window.history.replaceState(null, '', pathname);
    }
    
    // Additional safety check with setTimeout to override browser defaults
    const timer1 = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    
    const timer2 = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
